import { Epic, ofType } from "redux-observable";
import { RootState } from "../../store";
import * as userProfileActions from "./userProfileActions";
import { ServiceContainer } from "../../serviceContainer";
import * as shopActions from "../shop/shopActions";
import { map } from "rxjs/operators";

export const closeUpsertUserVoucherPopupOnSuccess: Epic<
  any,
  any,
  RootState,
  ServiceContainer
> = (action$, state$, services) =>
  action$.pipe(
    ofType(shopActions.UPSERT_USER_VOUCHER_SUCCESS),
    map((action: shopActions.UpsertUserVoucherSuccessAction) => {
      return userProfileActions.upsertVoucherPopupVisibleAction(
        action.organization,
        false,
        ""
      );
    })
  );
